import { ApiService } from 'js/src/client';
import {
    setAIAvatars,
    setAIAvatarVoicePresets,
} from 'js/src/data/ai-voices-and-avatars/ai-voices-and-avatars-actions';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';

export const fetchAvatars = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.aiAvatarList();
            const avatars = response.data;
            dispatch(setAIAvatars(avatars));
            return true;
        } catch (error) {
            ErrorReporter.capture(error);
            return false;
        }
    };
};

export const fetchAIAvatarVoicePresets = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.activeAiAvatarVoicePresetList();
            const presets = response.data;
            dispatch(setAIAvatarVoicePresets(presets));
            return true;
        } catch (error) {
            ErrorReporter.capture(error);
            return false;
        }
    };
};
